import { render, staticRenderFns } from "./common-header.vue?vue&type=template&id=7a9d8763&"
import script from "./common-header.vue?vue&type=script&lang=ts&"
export * from "./common-header.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports